export enum locationOfWfo{
    PUNE = "PUNE",
    BANGALORE = "BANGALORE",
    ARLINGTON = "ARLINGTON",
    USA_CLIENT = "USA_CLIENT_LOC",
    AUSTRALIA_CLIENT = "AUSTRALIA_CLIENT_LOC",
    IND_CLIENT = "IND_CLIENT_LOC"
}